import React, { useState, useEffect } from "react";
import { Tab, Nav, Container, Row, Col } from "react-bootstrap";
import jsDig from "utils/jsDig";

export default function App(props) {
  let logo = require("images/logos/dp-logo-vector.svg");
  logo = <img className="dp-logo-about-page" src={`/datapulse${logo}`} />;
  let icon = require("images/icons/datapulse-icon.png");
  icon = <img className="thumbnail" src={`/datapulse${icon}`} />;
  let tabletImg = require("images/tablet-datapulse.png");
  tabletImg = <img className="ob-datapulse-tablet" src={`/datapulse${tabletImg}`} />;

  return (
    <>
      <Container fluid>
        <Row className="navbar">
          <Col>
            <Row className="justify-content-left navbar-inner">
              <Col className="nav-link mr-auto"><a href="https://www.digitalposition.com">{logo}</a></Col>
              <Col className="nav-link"><p className="font-weight-bold"><a href="https://www.digitalposition.com/datapulse/login">Login to DataPulse</a></p></Col>
              <Col className="nav-link"><p className="font-weight-bold"><a href="https://www.digitalposition.com/privacy-policy">Privacy Policy</a></p></Col>
            </Row>
          </Col>
        </Row>
      </Container>
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} className="text-center">
            {icon}
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col xs={12} className="text-center">
            <h1 className="">DataPulse</h1>
            <h2>Real-time metrics reporting</h2>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col xs={12}>
            <div className="ob-copy">
              <p>You see everything we see in real time via our proprietary reporting platform, <b>DataPulse</b>. See organic traffic projections, all your keyword rankings, your personal team with their contact info, and more.</p>
              <div className="ob-anytime text-center">
                <p>Anytime, anywhere.</p>
              </div>
            </div>
          </Col>
          <Col xs={12}>
            <div className="tablet-container">
              {tabletImg}
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div style={{ height: "100px", display: "block" }} ></div>
          </Col>
        </Row>
        <Row>
          <Col>
            <p className="text-center">For assistance or help getting set up with DataPulse, contact your account representative or <br></br>datapulse@digitalposition.com</p>
          </Col>
        </Row>
        <Row>
          <Col>
            <div style={{ height: "200px", display: "block" }} ></div>
          </Col>
        </Row>
      </Container>
    </>
  )
}